<div>
    <div class="w-100-p" fxLayout="row" fxLayoutAlign="space-between center">
        <app-tag-multi-select [tags]="tagService.tag$ | async" storageKey="allowedModulesSelectedTags"> </app-tag-multi-select>
        <app-search-outline [searchInput]="searchInput"></app-search-outline>
    </div>
</div>
<ng-container *ngIf="filteredModule$ | async; else spinner">
    <div class="allowed-modules-content" fxLayout="column">
        <ng-container *ngIf="selectedExecutions.length">
            <h3 class="mb-8 text-base font-medium text-gray-600">{{ 'GENERAL.LABEL.SELECTED' | translate }}</h3>
            <mat-chip-list class="chip-list wrap mb-24">
                <mat-chip class="chip accent" [removable]="removable" (removed)="removeFromList(execution)" *ngFor="let execution of selectedExecutions">
                    {{ execution.name }}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </ng-container>

        <div class="w-100-p table-wrapper" *ngIf="dataSource">
            <mat-table #table [dataSource]="dataSource">
                <!-- Avatar Column -->
                <ng-container matColumnDef="avatar">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let module" class="avatar-cell cell-30 pl-20">
                        <div #avatarCell *ngIf="module.image; else moduleIconType">
                            <img class="avatar pointer" [alt]="module.name" [src]="module.image.thumbUrl" />
                        </div>
                        <ng-template #moduleIconType>
                            <div #avatarCell>
                                <div class="avatar pointer module-icon-container" fxLayoutAlign="center center">
                                    <mat-icon [svgIcon]="module | getModuleIcon"></mat-icon>
                                </div>
                            </div>
                        </ng-template>
                    </mat-cell>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="name">
                    <mat-header-cell class="pr-4" *matHeaderCellDef>{{ 'GENERAL.PROPERTY.NAME' | translate }}</mat-header-cell>
                    <mat-cell *matCellDef="let module" class="pr-4 text-truncate" fxLayout="column" fxLayoutAlign="center start">
                        <p class="text-truncate font-medium my-0 max-w-full" [matTooltip]="module.name" [matTooltipShowDelay]="500">{{ module.name }}</p>
                    </mat-cell>
                </ng-container>

                <!-- Version Column -->
                <ng-container matColumnDef="version">
                    <mat-header-cell *matHeaderCellDef class="pl-4">
                        <span class="text-sm leading-5 font-medium text-gray-600">{{
                            (isExecutionMode() ? 'GENERAL.PROPERTY.DATES_VERSION' : 'GENERAL.PROPERTY.VERSION') | translate
                        }}</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let module" class="pl-4">
                        <p class="text-truncate">{{ isExecutionMode() ? getDatesOrVersion(module) : module.version ? module.version : '-' }}</p>
                    </mat-cell>
                </ng-container>

                <!-- Content Column -->
                <ng-container matColumnDef="content">
                    <mat-header-cell *matHeaderCellDef class="pl-4">
                        <span class="text-sm leading-5 font-medium text-gray-600">{{ 'GENERAL.LABEL.CONTENT' | translate }}</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let module" class="pl-4">
                        <p class="text-truncate">{{ (module.hasSections ? 'SECTION.PLURAL' : 'GENERAL.LABEL.SCORM_FILE') | translate }}</p>
                    </mat-cell>
                </ng-container>

                <!-- Buttons Column -->
                <ng-container matColumnDef="buttons">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let module">
                        <div fxFlex="row" fxLayoutAlign="end center">
                            <app-flat-button
                                [label]="'GENERAL.BUTTON.SELECT'"
                                (onClick)="addToList(module)"
                                *ngIf="!isSelected(module)"
                                [disabled]="isSelectionLocked(module)"
                            ></app-flat-button>
                            <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(module)" *ngIf="isSelected(module)"></app-white-button>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let module; columns: displayedColumns" class="module" matRipple> </mat-row>
            </mat-table>
            <mat-paginator persistPageSize="module.allowed-modules-list" [length]="totalCount" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 50]" (page)="onPageChange($event)"> </mat-paginator>
        </div>
    </div>
</ng-container>
<ng-template #spinner>
    <div class="p-24 white" fxLayout="column" fxLayoutAlign="center center">
        <div class="p-24">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-template>
